import { Directive } from '@angular/core';

import { BaseMapDirective } from './base-map-directive';
import { NguiMapComponent } from '../components/ngui-map.component';

const INPUTS = [
  'center', 'clickable', 'draggable', 'editable', 'fillColor', 'fillOpacity', 'map', 'radius',
  'strokeColor', 'strokeOpacity', 'strokePosition', 'strokeWeight', 'visible', 'zIndex', 'options',
  // ngui-map specific inputs
  'geoFallbackCenter'
];
const OUTPUTS = [
  'centerChanged', 'click', 'dblclick', 'drag', 'dragend', 'dragstart',
  'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'radiusChanged', 'rightclick',
];

@Directive({
  selector: 'ngui-map>circle, ngui-map>map-circle',
  inputs: INPUTS,
  outputs: OUTPUTS,
})
export class Circle extends BaseMapDirective {
  // declare INPUTS for AOT compiler
  public center: any; // generated by ngc-pre-compiler.js
  public clickable: any; // generated by ngc-pre-compiler.js
  public draggable: any; // generated by ngc-pre-compiler.js
  public editable: any; // generated by ngc-pre-compiler.js
  public fillColor: any; // generated by ngc-pre-compiler.js
  public fillOpacity: any; // generated by ngc-pre-compiler.js
  public map: any; // generated by ngc-pre-compiler.js
  public radius: any; // generated by ngc-pre-compiler.js
  public strokeColor: any; // generated by ngc-pre-compiler.js
  public strokeOpacity: any; // generated by ngc-pre-compiler.js
  public strokePosition: any; // generated by ngc-pre-compiler.js
  public strokeWeight: any; // generated by ngc-pre-compiler.js
  public visible: any; // generated by ngc-pre-compiler.js
  public zIndex: any; // generated by ngc-pre-compiler.js
  public options: any; // generated by ngc-pre-compiler.js
  public geoFallbackCenter: any; // generated by ngc-pre-compiler.js

  // declare OUTPUTS for AOT compiler
  public centerChanged: any; // generated by ngc-pre-compiler.js
  public click: any; // generated by ngc-pre-compiler.js
  public dblclick: any; // generated by ngc-pre-compiler.js
  public drag: any; // generated by ngc-pre-compiler.js
  public dragend: any; // generated by ngc-pre-compiler.js
  public dragstart: any; // generated by ngc-pre-compiler.js
  public mousedown: any; // generated by ngc-pre-compiler.js
  public mousemove: any; // generated by ngc-pre-compiler.js
  public mouseout: any; // generated by ngc-pre-compiler.js
  public mouseover: any; // generated by ngc-pre-compiler.js
  public mouseup: any; // generated by ngc-pre-compiler.js
  public radiusChanged: any; // generated by ngc-pre-compiler.js
  public rightclick: any; // generated by ngc-pre-compiler.js

  public mapObject: google.maps.Circle;
  public objectOptions: google.maps.CircleOptions = <google.maps.CircleOptions>{};

  constructor(private nguiMapComp: NguiMapComponent) {
    super(nguiMapComp, 'Circle', INPUTS, OUTPUTS);
  }

  initialize(): void {
    super.initialize();
    this.setCenter();
  }

  setCenter(): void {
    if (!this['center']) {
      this._subscriptions.push(this.nguiMapComp.geolocation.getCurrentPosition().subscribe(
        center => {

          let latLng = new google.maps.LatLng(center.coords.latitude, center.coords.longitude);
          this.mapObject.setCenter(latLng);
        },
        error => {
          console.error('ngui-map, error in finding the current position');
          this.mapObject.setCenter(this.objectOptions['geoFallbackCenter'] || new google.maps.LatLng(0, 0));
        }
      ));
    } else if (typeof this['center'] === 'string') {
      this._subscriptions.push(this.nguiMapComp.geoCoder.geocode({address: this['center']}).subscribe(
        results => {

          this.mapObject.setCenter(results[0].geometry.location);
        },
        error => {
          console.error('ngui-map, error in finding location from', this['center']);
          this.mapObject.setCenter(this.objectOptions['geoFallbackCenter'] || new google.maps.LatLng(0, 0));
        }
      ));
    }
  }
}
